"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subtract = exports.sum = exports.convert = exports.getSymbol = exports.SYMBOL_MAP = exports.getLabel = exports.LABEL_MAP_PLURAL = exports.LABEL_MAP_SINGULAR = exports.Volume = exports.UsVolume = exports.UsGallon = exports.UsFluidOunce = exports.ImperialVolume = exports.ImperialGallon = exports.ImperialFluidOunce = exports.SiVolume = exports.Liter = exports.Deciliter = exports.Centiliter = exports.Milliliter = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
exports.NAMESPACE = 'Unit.Volume';
exports.Milliliter = effect_1.Schema.TaggedStruct('Milliliter', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Milliliter` });
exports.Centiliter = effect_1.Schema.TaggedStruct('Centiliter', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Centiliter` });
exports.Deciliter = effect_1.Schema.TaggedStruct('Deciliter', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Deciliter` });
exports.Liter = effect_1.Schema.TaggedStruct('Liter', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Liter` });
exports.SiVolume = effect_1.Schema.Union(exports.Milliliter, exports.Centiliter, exports.Deciliter, exports.Liter).annotations({
    identifier: `${exports.NAMESPACE}.SiVolume`,
    description: 'A unit of volume within the International System of Units (SI)',
    documentation: 'https://en.wikipedia.org/wiki/International_System_of_Units',
});
exports.ImperialFluidOunce = effect_1.Schema.TaggedStruct('ImperialFluidOunce', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.ImperialFluidOunce` });
exports.ImperialGallon = effect_1.Schema.TaggedStruct('ImperialGallon', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.ImperialGallon` });
exports.ImperialVolume = effect_1.Schema.Union(exports.ImperialFluidOunce, exports.ImperialGallon).annotations({
    identifier: `${exports.NAMESPACE}.ImperialVolume`,
    description: 'A unit of volume within the imperial system of units',
    documentation: 'https://en.wikipedia.org/wiki/Imperial_units',
});
exports.UsFluidOunce = effect_1.Schema.TaggedStruct('UsFluidOunce', { amount: effect_1.Schema.NonNegative }).annotations({
    identifier: `${exports.NAMESPACE}.UsFluidOunce`,
});
exports.UsGallon = effect_1.Schema.TaggedStruct('UsGallon', { amount: effect_1.Schema.NonNegative }).annotations({
    identifier: `${exports.NAMESPACE}.UsGallon`,
});
exports.UsVolume = effect_1.Schema.Union(exports.UsFluidOunce, exports.UsGallon).annotations({
    identifier: `${exports.NAMESPACE}.UsVolume`,
    description: 'A unit of volume within the United States customary system',
    documentation: 'https://en.wikipedia.org/wiki/United_States_customary_units',
});
exports.Volume = effect_1.Schema.Union(...exports.SiVolume.members, ...exports.ImperialVolume.members, ...exports.UsVolume.members).annotations({
    identifier: `${exports.NAMESPACE}.Volume`,
    description: 'A unit of volume in any system of units',
});
exports.LABEL_MAP_SINGULAR = {
    // SI
    Milliliter: 'milliliter',
    Centiliter: 'centiliter',
    Deciliter: 'deciliter',
    Liter: 'liter',
    // Imperial
    ImperialFluidOunce: 'fluid ounce',
    ImperialGallon: 'gallon',
    // US
    UsFluidOunce: 'fluid ounce',
    UsGallon: 'gallon',
};
exports.LABEL_MAP_PLURAL = {
    // SI
    Milliliter: 'milliliters',
    Centiliter: 'centiliters',
    Deciliter: 'deciliters',
    Liter: 'liters',
    // Imperial
    ImperialFluidOunce: 'fluid ounces',
    ImperialGallon: 'gallons',
    // US
    UsFluidOunce: 'fluid ounces',
    UsGallon: 'gallons',
};
/**
 * Retrieves the label corresponding to a given {@link Volume}-tag
 */
const getLabel = (volume) => volume.amount === 1 ? exports.LABEL_MAP_SINGULAR[volume._tag] : exports.LABEL_MAP_PLURAL[volume._tag];
exports.getLabel = getLabel;
exports.SYMBOL_MAP = {
    // SI
    Milliliter: 'mL',
    Centiliter: 'cL',
    Deciliter: 'dL',
    Liter: 'L',
    // Imperial
    ImperialFluidOunce: 'fl oz',
    ImperialGallon: 'gal',
    // US
    UsFluidOunce: 'fl oz',
    UsGallon: 'gal',
};
/**
 * Retrieves the symbol corresponding to a given {@link Volume}-tag
 */
const getSymbol = (tag) => exports.SYMBOL_MAP[tag];
exports.getSymbol = getSymbol;
/**
 * Ratio between {@link Milliliter} and other {@link Volume} unit of measure
 */
const FACTOR_MAP = {
    Milliliter: 1,
    Centiliter: 10,
    Deciliter: 100,
    Liter: 1_000,
    ImperialFluidOunce: 28.4131,
    ImperialGallon: 4_546.09,
    UsFluidOunce: 29.5735,
    UsGallon: 3_785.41,
};
/**
 * Converts any {@link Volume} to a specific volume measure
 */
exports.convert = effect_1.Function.dual(2, (volume, outTag) => {
    const ml = volume.amount * FACTOR_MAP[volume._tag];
    return {
        _tag: outTag,
        amount: ml / FACTOR_MAP[outTag],
    };
});
/**
 * Sums {@link Volume} quantities and returns the result in the unit of measure of the 0th parameter
 */
const sum = (volume, ...args) => effect_1.Array.reduce(args, volume, (acc, volume) => ({
    ...acc,
    amount: acc.amount + (0, exports.convert)(volume, acc._tag).amount,
}));
exports.sum = sum;
/**
 * Subtracts all rest parameter {@link Volume} quantities from the 0th parameter
 * and returns the result in the unit of measure of the 0th parameter
 */
const subtract = (volume, ...args) => effect_1.Array.reduce(args, volume, (acc, volume) => ({
    ...acc,
    amount: acc.amount - (0, exports.convert)(volume, acc._tag).amount,
}));
exports.subtract = subtract;
//# sourceMappingURL=volume.js.map